export default function LoadingFile() {
    return (
        <div className="fixed inset-0 z-50 flex cursor-progress items-center justify-center bg-slate-950/40 p-4 backdrop-blur-[3px]">
            <div className="flex w-full max-w-[320px] flex-col items-center text-center">
                <div className="relative flex h-16 w-16 items-center justify-center">
                    <div className="absolute inset-0 animate-ping rounded-full bg-[#186cb2]/20" />
                    <div className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#186cb2]/30 bg-white shadow-lg">
                        <svg className="h-7 w-7 animate-[downloadBounce_1.4s_ease-in-out_infinite] text-[#186cb2]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M12 3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5 21H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                </div>
                <p className="mt-3 text-sm font-semibold text-white drop-shadow-sm">
                    Downloading file
                </p>
                <div className="mt-2 h-1.5 w-40 overflow-hidden rounded-full bg-white/15">
                    <div className="h-full w-1/2 animate-[downloadProgress_1.5s_ease-in-out_infinite] rounded-full bg-[#186cb2]" />
                </div>
                <p className="mt-2 text-xs font-medium text-white/65">
                    Please wait while your file is being prepared
                </p>
                <style>{`
                    @keyframes downloadBounce {
                        0%, 100% {
                            transform: translateY(0);
                        }

                        50% {
                            transform: translateY(5px);
                        }
                    }
                    @keyframes downloadProgress {
                        0% {
                            transform: translateX(-100%);
                        }
                        50% {
                            transform: translateX(100%);
                        }
                        100% {
                            transform: translateX(250%);
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}